import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import SuperAdminLayout from '../components/SuperAdminLayout'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function SuperAdminOverview() {
  const [stats, setStats] = useState(null)
  const [clubs, setClubs] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      const { count: totalClubs } = await supabase.from('clubs').select('*', { count: 'exact', head: true })
      const { count: totalMembers } = await supabase.from('supporters').select('*', { count: 'exact', head: true })
      const { count: totalChapters } = await supabase.from('chapters').select('*', { count: 'exact', head: true })
      const { data: clubsData } = await supabase.from('clubs').select('*').order('created_at', { ascending: false })
      setStats({ totalClubs: totalClubs || 0, totalMembers: totalMembers || 0, totalChapters: totalChapters || 0 })
      setClubs(clubsData || [])
      setLoading(false)
    }
    fetchData()
  }, [])

  if (loading) return <LoadingSpinner fullScreen />

  const statCards = [
    { label: 'Total Clubs', value: stats.totalClubs },
    { label: 'Total Members', value: stats.totalMembers },
    { label: 'Total Chapters', value: stats.totalChapters },
  ]

  return (
    <SuperAdminLayout>
      <div className="mb-6 lg:mb-8">
        <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
          Platform Overview
        </h1>
        <p className="text-gray-500 text-sm">All clubs and activity across the DSMS platform</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 lg:gap-4 mb-8 lg:mb-10">
        {statCards.map((stat) => (
          <div key={stat.label} className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-4 lg:p-6">
            <div className="text-3xl lg:text-4xl font-black text-green-500 mb-2">{stat.value}</div>
            <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold">{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="mb-4">
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold">Registered Clubs</div>
      </div>

      <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-black/20">
              {['Club Name', 'Plan', 'Joined', ''].map((h) => (
                <th key={h} className="text-left py-3 px-4 text-xs text-gray-500 uppercase tracking-widest font-semibold whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {clubs.map((club) => (
              <tr key={club.id} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                <td className="py-3 px-4 font-bold text-gray-900 dark:text-white">{club.name}</td>
                <td className="py-3 px-4">
                  <span className="text-xs font-bold uppercase tracking-widest px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400">{club.subscription_plan}</span>
                </td>
                <td className="py-3 px-4 text-gray-500 text-xs whitespace-nowrap">
                  {new Date(club.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </td>
                <td className="py-3 px-4">
                  <span className="text-xs text-green-500 font-bold uppercase tracking-widest">Active</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SuperAdminLayout>
  )
}